module.exports = __webpack_public_path__ + "static/media/success.7bd03c95.svg";